import type { IChangeLogFields } from './model/changeLog'
import CatalogConfiguration from '@/models/catalogConfiguration'
import Net from '@/services/net'
import utils from '@/services/utils'

export function getChangeLogFields() {
  return Net.t1.get<IChangeLogFields>(`/organizations/changelogfields`)
}
export function getSellerConfiguration(sellerId: number) {
  return Net.t1.get<any>(`/sellers/${sellerId}/sellerConfigurations?topmostparent=true`).then((response) => {
    return response.data.map(x => new CatalogConfiguration(x))
  })
}

export function getChangeLogs(organizationId: number, requestObject: Record<string, any>, page?: number, pageSize?: number, cancelToken?) {
  const params = new URLSearchParams()
  if (utils.isDefined(page)) {
    params.set('page', page.toString())
  }
  if (utils.isDefined(pageSize)) {
    params.set('pageSize', pageSize.toString())
  }
  return Net.t1.post<any[]>(`/organizations/${organizationId}/changelogfields?${params.toString()}`, requestObject, { cancelToken })
}
